import { RootState } from "../store";

export const selectFeatures = (state: RootState) =>
  state.features.features;

export const selectLastUpdated = (state: RootState) =>
  state.features.lastUpdated;

export const selectPurchaseInProgress = (state: RootState) =>
  state.features.purchaseInProgress;

export const selectPurchaseSuccess = (state: RootState) =>
  state.features.purchaseSuccess;

export const selectHasFeature = (feature: string) => (state: RootState) =>
  state.features.features.includes(feature);
